import { uniqueId } from "library/database/split-id.mjs"

// summary colors from assess-status.js, implying tailoring
const TAILORING_SUMMARIES = ["cyan", "skyblue", "orange", "red"]

export function isTailoredScheduleNode({ parentItem, schedule } = {}) {
    const status = parentItem?.data?.statuses?.[uniqueId(schedule?._id)]
    const summary = typeof status === "string" ? status : status?.summary
    return TAILORING_SUMMARIES.includes(summary)
}
